module.exports = __webpack_public_path__ + "static/media/react.6f14b6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/react.png
// module id = 1503
// module chunks = 0